(() => {
  function setup(scope = document) {
    scope.querySelectorAll('.mmc-nav').forEach(nav => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const groups = [...nav.querySelectorAll('.mmc-nav__group')];
      groups.forEach(group => group.addEventListener('toggle', () => {
        if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
      }));
      nav.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const opened = groups.find(group => group.open);
        if (opened) { opened.open = false; opened.querySelector('summary').focus(); event.stopPropagation(); }
      });
      document.addEventListener('click', event => { if (!nav.contains(event.target)) groups.forEach(group => { group.open = false; }); });
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
